module.exports = __webpack_public_path__ + "img/logo_strip@2x.66f9d0d7.png";